(function () {
  const ROTATION_INTERVAL_MS = 600;
  const IMAGE_ZOOM = 1.05;

  const desktopQuery = window.matchMedia(
    '(hover: hover) and (pointer: fine)'
  );

  const imageCache = new Map();

  function addCollectionStyles() {
    if (document.querySelector('#oxy-collection-hover-styles')) {
      return;
    }

    const style = document.createElement('style');
    style.id = 'oxy-collection-hover-styles';

    style.textContent = `
      /*
        Disattiva l'ingrandimento globale sulla card.
        L'effetto verrà applicato solo all'immagine.
      */
      .product-card a:hover,
      .product-card button:hover,
      .card-wrapper a:hover,
      .card-wrapper button:hover,
      [data-product-card] a:hover,
      [data-product-card] button:hover,
      .grid__item a:hover,
      .grid__item button:hover {
        transform: none !important;
      }

      /*
        Effetto zoom esclusivamente sull'immagine,
        solo quando il dispositivo dispone di un mouse.
      */
      @media (hover: hover) and (pointer: fine) {
        .oxy-collection-image-hover .product-media__image {
          transform: scale(${IMAGE_ZOOM}) !important;
          transform-origin: center center;
        }

        .product-media__image {
          transition: transform 0.25s ease;
          transform-origin: center center;
        }
      }

      /*
        Nessun effetto zoom su smartphone.
      */
      @media (hover: none) {
        .product-media__image,
        .product-media__image:hover,
        .product-card:hover .product-media__image,
        .card-wrapper:hover .product-media__image,
        [data-product-card]:hover .product-media__image {
          transform: none !important;
          transition: none !important;
        }
      }
    `;

    document.head.appendChild(style);
  }

  async function getProductImages(handle) {
    if (imageCache.has(handle)) {
      return imageCache.get(handle);
    }

    const request = fetch(
      `/products/${encodeURIComponent(handle)}.js`
    )
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Product request failed');
        }

        return response.json();
      })
      .then(function (product) {
        const seen = new Set();

        return (product.images || [])
          .map(function (image) {
            if (typeof image === 'string') {
              return image;
            }

            return image && image.src
              ? image.src
              : null;
          })
          .filter(function (src) {
            if (!src || seen.has(src)) {
              return false;
            }

            seen.add(src);
            return true;
          })
          .map(function (src) {
            if (src.startsWith('//')) {
              return window.location.protocol + src;
            }

            return src;
          });
      })
      .catch(function () {
        return [];
      });

    imageCache.set(handle, request);

    return request;
  }

  function getProductHandle(card) {
    const link = card.querySelector(
      'a[href*="/products/"]'
    );

    if (!link) {
      return null;
    }

    try {
      const productUrl = new URL(link.href, window.location.origin);
      const parts = productUrl.pathname.split('/products/');

      if (!parts[1]) {
        return null;
      }

      return decodeURIComponent(
        parts[1].split('/')[0]
      );
    } catch (error) {
      return null;
    }
  }

  function getProductCards() {
    const selector = [
      '.product-card',
      '.card-wrapper',
      '[data-product-card]',
      '.grid__item'
    ].join(', ');

    const candidates = Array.from(
      document.querySelectorAll(selector)
    );

    /*
      Evita di inizializzare contenitori duplicati
      quando una card è dentro più wrapper del tema.
    */
    const cards = [];

    candidates.forEach(function (candidate) {
      const image = candidate.querySelector(
        '.product-media__image'
      );

      const link = candidate.querySelector(
        'a[href*="/products/"]'
      );

      if (!image || !link) {
        return;
      }

      const alreadyIncluded = cards.some(function (card) {
        return card.contains(candidate);
      });

      if (!alreadyIncluded) {
        cards.push(candidate);
      }
    });

    return cards;
  }

  async function initCard(card) {
    if (card.dataset.oxyCollectionReady === 'true') {
      return;
    }

    const image = card.querySelector(
      '.product-media__image'
    );

    if (!image) {
      return;
    }

    const imageArea =
      image.closest('.product-media') ||
      image.parentElement;

    if (!imageArea) {
      return;
    }

    const handle = getProductHandle(card);

    if (!handle) {
      return;
    }

    card.dataset.oxyCollectionReady = 'true';

    const originalSrc = image.getAttribute('src');
    const originalSrcset = image.getAttribute('srcset');
    const originalSizes = image.getAttribute('sizes');

    const images = await getProductImages(handle);

    /*
      Anche con una sola immagine manteniamo
      l'effetto zoom desktop.
    */
    if (!desktopQuery.matches) {
      return;
    }

    if (!images || images.length < 2) {
      imageArea.addEventListener(
        'mouseenter',
        function () {
          imageArea.classList.add(
            'oxy-collection-image-hover'
          );
        }
      );

      imageArea.addEventListener(
        'mouseleave',
        function () {
          imageArea.classList.remove(
            'oxy-collection-image-hover'
          );
        }
      );

      return;
    }

    let currentImageIndex = 0;
    let rotationTimer = null;

    function showImage(index) {
      if (!images[index]) {
        return;
      }

      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = images[index];
    }

    function startRotation() {
      if (!desktopQuery.matches) {
        return;
      }

      if (rotationTimer) {
        return;
      }

      imageArea.classList.add(
        'oxy-collection-image-hover'
      );

      /*
        Cambio immediato da immagine 1 a immagine 2.
      */
      currentImageIndex = 1 % images.length;
      showImage(currentImageIndex);

      rotationTimer = window.setInterval(function () {
        currentImageIndex =
          (currentImageIndex + 1) % images.length;

        showImage(currentImageIndex);
      }, ROTATION_INTERVAL_MS);
    }

    function stopRotation() {
      if (rotationTimer) {
        window.clearInterval(rotationTimer);
        rotationTimer = null;
      }

      imageArea.classList.remove(
        'oxy-collection-image-hover'
      );

      currentImageIndex = 0;

      /*
        Torna alla prima immagine e ripristina
        srcset e sizes originali del tema.
      */
      if (originalSrcset) {
        image.setAttribute('srcset', originalSrcset);
      } else {
        image.removeAttribute('srcset');
      }

      if (originalSizes) {
        image.setAttribute('sizes', originalSizes);
      } else {
        image.removeAttribute('sizes');
      }

      if (originalSrc) {
        image.src = originalSrc;
      }
    }

    imageArea.addEventListener(
      'mouseenter',
      startRotation
    );

    imageArea.addEventListener(
      'mouseleave',
      stopRotation
    );
  }

  function initCollectionCards() {
    addCollectionStyles();

    if (!desktopQuery.matches) {
      return;
    }

    getProductCards().forEach(function (card) {
      initCard(card);
    });
  }

  function start() {
    initCollectionCards();

    /*
      Supporta sezioni caricate successivamente
      dal Theme Editor o dal caricamento dinamico.
    */
    document.addEventListener(
      'shopify:section:load',
      initCollectionCards
    );

    window.setTimeout(initCollectionCards, 500);
    window.setTimeout(initCollectionCards, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start
    );
  } else {
    start();
  }
})();
